var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isIconfont)?_c('i',{class:['iconfont', _vm.iconClass],style:(_vm.iconStyle)}):_c('span',{class:_vm.iconClass,style:(_vm.iconStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }